// extracted by mini-css-extract-plugin
module.exports = {"title":"WeeklyAnalysis_title__2wEpi"};